export default __webpack_public_path__ + "3e90f00c0a9eaa1868ef0ccc8d0781dd.png";